import { apiRequest } from "api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  POST_REQUESTED_DOCS,
  GET_REQUESTED_DOC_BY_REQ_ID,
  GET_DASHBOARD_DETAIL_CONFIG_BY_ORGANISATION_ID_AND_CONFIG_TYPE,
  GET_VKYC_STATUS_ON_PRIMARY_WORKFLOW_ID,
  SEND_VKYC_REMINDER_TO_USER,
} from "./apiUrls";
import { encryptPayload } from "./encrypt";
import { BASE_URL } from "constants/routes";
import {
  resetSuccessFullySentTouser,
  seEditUserDataRoutedSuccessFully,
  setuserSubworkFlowInfo,
  setSuccessFullySentTouser,
} from "redux/dashBoardDetailReducer";
import { clearToastMessagesState } from "redux/vkycReducer";
import { getIndianTime } from "helper/common";

export const postRequestedDocs = createAsyncThunk(
  "work-flow/postRequestedDocs",
  async (queryObj, { dispatch }) => {
    const { primaryWorkflowId, userId, subWfId, organisation_id } =
      queryObj.params;
    const req = POST_REQUESTED_DOCS(
      primaryWorkflowId,
      userId,
      subWfId,
      organisation_id
    );
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      // * Adding a timestamp to capture any changes mde via this API
      body: JSON.stringify({...queryObj.body, last_modified_at : getIndianTime()}),
    };
    try {
      const result = await apiRequest(req, options,true);
      // dispatch(setSuccessFullySentTouser());
      if (result.link) {
        dispatch(seEditUserDataRoutedSuccessFully());
        window.open(result.link, "_blank");
        setTimeout(() => {
          dispatch(resetSuccessFullySentTouser());
        }, 3000);
      } else {
        dispatch(setSuccessFullySentTouser());
        setTimeout(() => {
          dispatch(resetSuccessFullySentTouser());
        }, 3000);
      }
      return result.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getRequestedDocByReqId = createAsyncThunk(
  "work-flow/getRequestedDocByReqId",
  async (queryObj) => {
    const { primaryWorkflowId, userId, subWfId, requestedId } = queryObj;
    const req = GET_REQUESTED_DOC_BY_REQ_ID(
      primaryWorkflowId,
      userId,
      subWfId,
      requestedId
    );
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const result = await apiRequest(req, options,true);
      return result;
    } catch (error) {
      throw error;
    }
  }
);

export const fetchWorkflowInfoById = createAsyncThunk(
  "workflow/fetchWorkflowInfoById",
  async (id, { dispatch }) => {
    const req = `${BASE_URL}/workflow/getWorkflowInfo`;
    let params = {
      body: { _id: id,getDocumetsData:true },
    };
    const encryptedBodyRes = await encryptPayload("", params, true, true);

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encryptedBodyRes),
    };
    try {
      const result = await encryptPayload(req, options, false, true,true);
      // const result = await encryptPayload(req, _options, false, false);
      delete result.data?._id;
      return result.data;
    } catch (err) {
      // console.log(err);
    }
  }
);


export const fetchSubWorkflowInfoById = createAsyncThunk(
  "workflow/fetchSubWorkflowInfoById",
  async (id) => {
    const req = `${BASE_URL}/workflow/getWorkflowInfo`;

    let params = {
      body: { _id: id,getDocumetsData:true },
    };
    const encryptedBodyRes = await encryptPayload("", params, true, true);

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encryptedBodyRes),
    };
    try {
      const result = await encryptPayload(req, options, false, true,true);
      // const result = await encryptPayload(req, _options, false, false);
      // dispatch(setuserSubworkFlowInfo(result.data))
      delete result.data?._id;
      return result.data;
    } catch (err) {
      // console.log(err);
    }
  }
);

export const updateDataAndStatusById = createAsyncThunk(
  "workflow/updateDataAndStatusById",
  async (body, { dispatch }) => {
    const req = `${BASE_URL}/workflow/updateDataAndStatusById`;

    // * Adding a timestamp to capture the changes made via this API
    let params = {
      body: {...body, last_modified_at : getIndianTime()},
    };
    const encryptedBodyRes = await encryptPayload("", params, true, true);
    const _options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encryptedBodyRes),
    };

    try {
      const result = await encryptPayload(req, _options, false, true,true);
      // console.log(result?.data);
      if (result?.data?.updateInfo?.primary_workflow_id) {
        dispatch(
          fetchWorkflowInfoById(result?.data?.updateInfo?.primary_workflow_id)
        );
      }
      return result.data;
    } catch (err) {
      console.log(err);
    }
  }
);

export const ncifResponse = createAsyncThunk(
  "workflow/ncifResponse",
  async (body) => {
    const req = `${BASE_URL}/workflow/ncifResponse`;
    const _options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };

    try {
      const result = await encryptPayload(req, _options, false, false,true);
      return result.data;
    } catch (err) {
      // console.log(err);
    }
  }
);

export const fetchAgreementsOfSubWorkflow = createAsyncThunk(
  "workflow/fetchAgreementsOfSubWorkflow",
  async (body) => {
    const req = `${BASE_URL}/workflow/getAllDocuments`;
    let params = {
      body: body,
    };
    const encryptedBodyRes = await encryptPayload("", params, true, true);

    const _options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encryptedBodyRes),
    };

    try {
      const result = await encryptPayload(req, _options, false, true,true);
      return result.data;
    } catch (err) {
      console.log(err);
    }
  }
);

export const fetchDashboardDetailConfiguration = createAsyncThunk(
  "workflow/fetchDashboardDetailConfiguration",
  async (body) => {
    const req = GET_DASHBOARD_DETAIL_CONFIG_BY_ORGANISATION_ID_AND_CONFIG_TYPE;
    let params = {
      body: body,
    };
    const encryptedBodyRes = await encryptPayload("", params, true, true);

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encryptedBodyRes),
    };

    try {
      const result = await encryptPayload(req, options, false, true,true);
    //redirecting to error page if the user is not authorized to view the application      
      if (result?.status == "failed"){
        window.location.href = "/unified/error"
      }
      // const result = await apiRequest(req, _options);
      return result.data;
    } catch (err) {
      console.log(err);
    }
  }
);

export const fechVKYCDataByPrimaryWorkflowId = createAsyncThunk(
  "workflow/fechVKYCDataByPrimaryWorkflowId",
  async (primaryWorkflowId) => {
    const req = GET_VKYC_STATUS_ON_PRIMARY_WORKFLOW_ID(primaryWorkflowId);
    const _options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };

    try {
      const result = await apiRequest(req, _options,true);
      return result.data;
    } catch (err) {
      console.log(err);
    }
  }
);

export const sendVKYCReminderToUser = createAsyncThunk(
  "workflow/sendVKYCReminderToUser",
  async (body, { dispatch }) => {
    const req = SEND_VKYC_REMINDER_TO_USER;
    const _options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };
    try {
      const result = await apiRequest(req, _options,true);

      setTimeout(() => {
        dispatch(clearToastMessagesState());
      }, 5000);
      return result.data;
    } catch (err) {
      console.log(err);
    }
  }
);

export const welcomeLetter = createAsyncThunk(
  "workflow/welcomeLetter",
  async ({ sub_id, organisation_id, trigger }) => {
    const req = `${BASE_URL}/organisation/getwelcomeletter`;
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        sub_id: sub_id,
        organisation_id: organisation_id,
        trigger: trigger,
      }),
    };
    try {
      const result = await apiRequest(req, options,true);
      return result.data;
    } catch (err) {
      console.log(err);
    }
  }
);

export const linkCrnToWorkflow = createAsyncThunk(
  "workflow/linkCrnToWorkflow",
  async (body, { dispatch }) => {
    const req = `${BASE_URL}/workflow/linknumberToWorkflow`;
    let params = {
      body: body,
    };
    const encryptedBodyRes = await encryptPayload("", params, true, true);
    const _options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encryptedBodyRes),
    };

    try {
      const result = await encryptPayload(req, _options, false, true,true);
      // if (result?.data?._id) {
      //   dispatch(fetchWorkflowInfoById(result?.data?._id));
      // }
      return result;
    } catch (err) {
      return {
        status: "failed",
        message: "No applicant found with the given CRN",
        data: {},
      }
    }
  }
);

export const sendreminderAboutStatus = createAsyncThunk(
  "workflow/sendreminderAboutStatus",
  async (body, { dispatch }) => {
    const req = `${BASE_URL}/workflow/sendReminder`;
    const _options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };

    try {
      const result = await encryptPayload(req, _options, false, false,true);
      return result;
    } catch (err) {}
  }
);

export const reInitiateVkyc = createAsyncThunk("vkyc/reInitiateVkyc", async(payload) => {
  const req = `${BASE_URL}/vkyc/reInitiateVkyc`;
  let params = {
    body: payload,
  };
  const encryptedBodyRes = await encryptPayload("", params, true, true);
  const _options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try{
    const result = await encryptPayload(req,_options,false,true,true);
    return result;
  }catch(err){
    return({
      status: "failed",
      messsage: "reinitiate vkyc failed",
      data: {}
    })
  }
});

export const terminateOrRevokeApplication = async (payload) =>{
  const req = `${BASE_URL}/workflow/initiateApplicationTermination`;
  let params = {
    body: payload,
  };
  const _options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  };
  try{
    const result = await encryptPayload(req,_options,false,true);
    return result;
  }catch(err){
    return({
      status: "failed",
      messsage: "Failed",
      data: {}
    })
  }
}

export const sendReminderForEsign = createAsyncThunk("sendReminderForEsign" ,async(payload) => {
  const req = `${BASE_URL}/workflow/esignCompletionReminder`;
  let params = {
    body: payload,
  };
  const encryptedBodyRes = await encryptPayload("", params, true, true);
  const _options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try{
    const result = await encryptPayload(req,_options,false,false);
    return result;
  }catch(err){
    return({
      status: "failed",
      messsage: "failed to send reminder",
      data: {}
    })
  }
});
export const bankVerification = createAsyncThunk("workflow/pennydropverification", async(payload) => {
 
  let params = payload; 
  
  let endpoint;
 
  if(params?.verificationType == 'pennydrop') {
     endpoint = `${BASE_URL}/workflow/pennydropverification`;
  } 
  else if (params?.verificationType == 'pennyless'){
    endpoint = `${BASE_URL}/workflow/pennylessverification`;
  }
  
  const encryptedBodyRes = await encryptPayload("", params, true, true);

  const _options = {
    method: "POST",
    headers: {
      "Content-Type" : "application/json",
    },
    body: JSON.stringify(params)
  }

  try {
    const result = await encryptPayload(endpoint, _options, false, false)
    return result
    
  } catch (error) {
    return({
      status: "Failed",
      message: "Failed to Verify Bank Account",
      data: error
    })  
  }
}) 

export const getEmandateStatus = createAsyncThunk("getEmandateStatus" ,async(payload) => {
  const req = `${BASE_URL}/workflow/emandateStatus`;
  let params = {
    body: payload,
  };
  const encryptedBodyRes = await encryptPayload("", params, true, true);
  const _options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try{
    const result = await encryptPayload(req,_options,false,false);
    return result;
  }catch(err){
    return({
      status: "failed",
      messsage: "failed to fetch status",
      data: {}
    })
  }
});

export const cancelEmandate = createAsyncThunk("getEmandateStatus" ,async(payload) => {
  const req = `${BASE_URL}/workflow/cancelEmandate`;
  let params = {
    body: payload,
  };
  const encryptedBodyRes = await encryptPayload("", params, true, true);
  const _options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try{
    const result = await encryptPayload(req,_options,false,false);
    return result.data;
  }catch(err){
    return({
      status: "failed",
      messsage: "failed to fetch status",
      data: {}
    })
  }
});
export const updateCrData = async (payload) =>{
  const req = `${BASE_URL}/dashboard-configuration/updateCrData`;
  let params = {
    body: payload,
  };
  const encryptedBodyRes = await encryptPayload("", params, true, true);
  const _options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try{
    const result = await encryptPayload(req,_options,false,false);
    return result;
  }catch(err){
    return({
      status: "failed",
      messsage: "Failed",
      data: {}
    })
  }
}


export const fetchSuccessPageContent = async (payload) =>{
  const req = `${BASE_URL}/workflow/fetchSuccessPageContent`;
  let params = {
    body: payload,
  };
  const encryptedBodyRes = await encryptPayload("", params, true, true);
  const _options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try{
    const result = await encryptPayload(req,_options,false,false);
    return result;
  }catch(err){
    return({
      status: "failed",
      messsage: "Failed",
      data: {}
    })
  }
}
